export default __webpack_public_path__ + "static/bannerFenaTerminal-9f0817283ca961ea4a63d5e3c46cff38.png";